'use strict'

const map_ = require('lodash/map')
const getUniqueComponents = require('./getUniqueComponents')
const isInputComponent = require('dbsm-common/src/isInputComponent')

module.exports = contexts =>
  getUniqueComponents(map_(contexts, 'component').filter(isInputComponent))



// WEBPACK FOOTER //
// ./helpers/getInputComponents.js